import React from "react";
import { connect } from "react-redux";
import Emitter from "_actions/emitter";
import i18n from "i18n";

const DEFAULT_METHODS = [
  { id: "fastpay", label: "FastPay", icon: require("../../../assets/img/payTypes/fastpay.png") },
  { id: "fib", label: "FiB", icon: require("../../../assets/img/payTypes/fib.png") },
  { id: "zaincash", label: "ZainCash", icon: require("../../../assets/img/payTypes/zaincash.png") },
  { id: "naswallet", label: "Nas Wallet", icon: require("../../../assets/img/payTypes/nasswallet.png") },
  { id: "usdt", label: "USDT", icon: require("../../../assets/img/payTypes/usdt.png") },
  { id: "nasspay", label: "NASS PAY", icon: require("../../../assets/img/payTypes/nasspay.png") },
];

const PaymentMethodBadge = ({ label, icon, loggedIn }) => {
  const handleActivate = () => {
    if (!loggedIn) {
      Emitter.emit("LOGIN_MODAL", true);
      return;
    }
    Emitter.emit("BALANCE_MODAL", "deposit");
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={handleActivate}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleActivate();
        }
      }}
      aria-label={i18n.t("BALANCE_MODAL_DEPOSIT_BUTTON")}
      className="group flex h-14 w-[84px] shrink-0 cursor-pointer items-center justify-center rounded-lg border border-white/10 bg-white/[0.03] grayscale transition-all duration-200 hover:grayscale-0 hover:border-primary-400/40 hover:bg-white/[0.08]"
      title={label}
    >
      {icon ? (
        <img src={icon} alt={label} className="max-h-8 max-w-[68px] object-contain opacity-70 transition-opacity group-hover:opacity-100" />
      ) : (
        <span className="text-[10px] text-gray-400">{label}</span>
      )}
    </div>
  );
};

/**
 * Payment methods badge row — footer-styled, matching the other
 * footer columns (heading + wrap of items), no marquee/card panel.
 *
 * Props:
 * - items?: {id: string, label: string, icon: string}[]
 * - className?: string
 */
const PaymentMethods = ({ items = DEFAULT_METHODS, className = "", loggedIn }) => {
  return (
    <div className={["text-center md:text-left", className].join(" ")}>
      <div className="flex flex-wrap justify-center gap-2 md:justify-start">
        {items.map((it) => (
          <PaymentMethodBadge key={it.id} label={it.label} icon={it.icon} loggedIn={loggedIn} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { authentication } = state;
  return {
    loggedIn: authentication.loggedIn,
  };
};

export default connect(mapStateToProps)(PaymentMethods);
